export const device = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
    serialNo: { en: 'SerialNo.', ko: '시리얼 번호', fr: '' },
    registDate: { en: 'Registration date', ko: '등록날짜', fr: '' },
    deviceAlias: { en: 'Device Alias', ko: '장치 별칭', fr: '' },
  },
  info: {
    name: { en: 'Name', ko: '이름', fr: '' },
    connectionPatient: { en: 'Connected patient', ko: '연결환자 ', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    serialNo: { en: 'Serial no.', ko: '시리얼번호', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
    registDate: { en: 'Registration date', ko: '등록날짜', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
    log: { en: 'Log', ko: '로그', fr: '' },
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    deviceAlias: { en: 'Device Alias', ko: '장치 별칭', fr: '' },
    connectionStatus: { en: 'Connection Status', ko: '연결상태', fr: '' },
  },
  csv: {
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    serial_no: { en: 'Serial no.', ko: '시리얼번호', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
    active: { en: 'Status', ko: '상태' },
  },
  select: {
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
  },
  placeholder: {
    serial: { en: 'Search by serial number', ko: '시리얼 번호를 입력하세요', fr: '' },
  },
  data: {
    noPatient: { en: 'none', ko: '없음', fr: '' },
  },
  confirm: {
    cannotDeactivateTitle: {
      en: 'Cannot deactivate device',
      ko: '장치를 비활성화할 수 없습니다',
      fr: '',
    },
    connectedPatientGuide: {
      en: 'This device is connected to the patient(s) below and cannot be deactivated.\nGo to the patient and disconnect the device first.',
      ko: '이 장치는 아래 환자에게 연결되어 있어 비활성화할 수 없습니다.\n환자로 이동하여 장치 연결을 해제해 주세요.',
      fr: '',
    },
    goToPatient: {
      en: 'Go',
      ko: '이동',
      fr: '',
    },
  },
};
